import React, {
  useReducer,
  useMemo,
  useState,
  useEffect,
  useContext,
  Fragment,
  useRef,
} from "react";
import ReactDOM from "react-dom/client";
import Moment from "moment";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from "react-query";

import "./StudyListTable.css";

import {
  PaginationState,
  useReactTable,
  getCoreRowModel,
  ColumnDef,
  flexRender,
  getExpandedRowModel,
  createRow,
  expandRows,
  RowSelection,
} from "@tanstack/react-table";
import { forwardRef, useImperativeHandle } from "react";
// import { StudyListColumns } from "../../constants/Columns/StudyList";
import PatientDetails from "../../pages/StudyList/components/PatientDetails";
import StudyDetails from "../../pages/StudyList/components/StudyDetails";
import TriageDetails from "../../pages/StudyList/components/TriageDetails";
import RadiologistDetails from "../../pages/StudyList/components/RadiologistDetails";
import ReportDetails from "../../pages/StudyList/components/ReportDetails";
import ClientDetails from "../../pages/StudyList/components/ClientDetails";
import QCDetails from "../../pages/StudyList/components/QCDetails";
import BrowserCheck from "../../pages/StudyList/components/BrowserCheck";
import {
  Checkbox,
  DefaultButton,
  Icon,
  PrimaryButton,
  Spinner,
  SpinnerSize,
  Stack,
  TooltipHost,
} from "@fluentui/react";
import Accordian from "../SVGComponents/Accordian";
import Lock from "../SVGComponents/Lock";
import ActionDetails from "../../pages/StudyList/components/ActionDetails";
import loaderContext from "../../context/loader/LoaderContext";
import { t } from "i18next";
import {
  assignMe,
  assignMeSupervisor,
  batchAssignProvider,
  batchDeleteStudyApi,
  batchReinferenceStudyApi,
  getPriors,
  getStudyStatus,
} from "../../service/StudyListService";
import { CSSTransition, Transition } from "react-transition-group";
import { Navigate } from "react-router";
import ConfirmModal from "../Modal/ConfirmModal";
import TablePaginationv2 from "../TablePaginationv2/TablePaginationv2";

import userContext from "../../context/users/UserContext";
import {
  ARCHIVED_STUDY_TABS_NAME,
  CXR_TABS_NAME,
  HIDE_LOCK_ICON_TABS,
  PEER_REVIEW_TABS,
  PEER_REVIEW_TABS_NAME,
  QC_TABS,
  QC_TABS_NAME,
  REPORTDONESTATUS,
  SAVED_TABS_NAME,
  STORAGE_TYPE,
  TAB_NAME,
  TOAST_TYPE,
  USERTYPES,
  widthOfColumns,
} from "../../constants/Constants";
import toastContext from "../../context/toast/ToastContext";
import StudylistState from "../../context/studylist/StudylistState";
import LockOpen from "../SVGComponents/LockOpen";
import studylistContext from "../../context/studylist/StudylistContext";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import MobileListComponent from "../../pages/StudyList/components/MobileListComponent";
import LoadingBar from "react-top-loading-bar";
import { ReactQueryDevtools } from "react-query/devtools";
import ImageArchivalAccessForm from "../../pages/StudyList/components/Modal/ImageArchive/ImageArchivalAccessForm";

import IndeterminateCheckbox from "../../pages/StudyList/components/IndeterminateCheckbox/IndeterminateCheckbox";
import { getStudyListTableHeader } from "../../pages/StudyList/components/StudyListTableHeader/StudyListTableHeaders";
import MobileStudyListTable from "./MobileStudyListTable";
import DesktopStudyListTable from "./DesktopStudyListTable";
import RequestDetails from "../../pages/StudyList/components/RequestDetails";
const StudyListTable = (props) => {
  const isVdcPlatform = process.env.REACT_APP_VDC_PLATFORM === "true" || process.env.REACT_APP_VDC_PLATFORM === true;

  const { ref, setLoaderRunning } = useContext(loaderContext);

  const { showToastv2, updateToastv2, list, setList,setBatchAssignClick,batchAssignClick } =
    useContext(toastContext);
  const { roles, username, userId } = useContext(userContext);
  const rerender = useReducer(() => ({}), {})[1];
  const id = props.id;
  const sortObj = props.sortObj;
  const pageObj = props.pageObj;
  const pageIndexFromParent = props.pageObj.pageIndex;
  const filterObj = props.filterObj;
  const [rowSelection, setRowSelection] = useState({});
  const [arrayPageIndex, setArrayPageIndex] = useState([]);
  const [providerDtoList, setProviderDtoList] = useState([]);
  const [assignToastId, setAssignToastId] = useState(0);
  const defaultData = useMemo(() => [], []);
  const [expanded, setExpanded] = useState({});
  const queryClient = useQueryClient();

  const [isChrome, setIsChrome] = useState(true);

  let isBvpPlatform = (process.env.REACT_APP_BVP_PLATFORM == "true" || process.env.REACT_APP_BVP_PLATFORM == true) ? true : false;


  const [containerHeight, setContainerHeight] = useState(() => {
    const newScreenHeight = window.innerHeight;
    const monitorScreenHeightThreshold = 820;
    if (CXR_TABS_NAME.includes(props.id) || PEER_REVIEW_TABS_NAME.includes(props.id) || ARCHIVED_STUDY_TABS_NAME.includes(props.id) || (SAVED_TABS_NAME.includes(props.id) && isBvpPlatform)) {
      if (newScreenHeight >= monitorScreenHeightThreshold) {
        return "69vh";
      } else {
        return "64vh";
      }
    } else {
      if (newScreenHeight >= monitorScreenHeightThreshold) {
        return "74vh";
      } else {
        return "70vh";
      }
    }
  });

  const {
    filterInputValues,
    showCount,
    setShowCount,
    refreshRequired,
    setRefreshRequired,
    storedRows,
    setStoredRows,
    studyListLoading,
    setStudyListLoading,
    studyListRef,
    dataQueryState,
    setDataQueryState,
    updateLockUnlockRows,
    setUpdateLockUnlockRows,
    setSearchResultLength,
    menuItemsForBatchAndInference,
    rowSelectionState,
    setRowSelectionState,
    setRowSelectedArray,
    rowSelectedArray,
    getCountOfAbleToDeleteStudies,
    handleBatchReInference,
    batchReinferenceAndDeleteArray,
    resetRowSelection,
    setResetRowSelection,
    handleBatchDelete,
    unreportedAllTabs,
    fetchData,
    sortGlobal,
    setFirstTimeLoading,
    totalRecordCount,
    activeTab,
    runPaginationAlgo,
    searchResultLength,
    studyCounts,
    studyCountLoading
  } = useContext(studylistContext);

  const [{ pageIndex, pageSize }, setPagination] = useState({
    pageIndex: props.pageObj.pageIndex,
    pageSize: props.pageObj.pageSize,
  });
  let baseURL = window.location.origin + "/"
  //let enterprise = (process.env.REACT_APP_ENTERPRISE_PLATFORM == "true" || process.env.REACT_APP_ENTERPRISE_PLATFORM == true) ? true : false;
  const loggedInUserRole = props.roles[0];

  const fetchDataOptions = {
    pageIndex: pageIndexFromParent,
    showCount,
    pageSize,
    sortObj,
    id,
    filterObj,
    //refreshRequired
  };

  const pagination = useMemo(
    () => ({
      pageIndex,
      pageSize,
    }),
    [pageIndex, pageSize]
  );

  useEffect(() => {
    if (dataQuery != undefined && dataQuery != null) {
      // console.log("--- Refetching data ---", dataQuery);
      setSearchResultLength(dataQuery?.data?.rows?.length);
      props.setDataQueryParent(dataQuery);
      setDataQueryState(dataQuery);
    }
  }, [pageIndex, pageSize, pageIndexFromParent,sortGlobal]);

  useEffect(() => {
    setPagination({ pageIndex: pageIndexFromParent, pageSize: pageSize });
  }, [pageIndexFromParent]);

  useEffect(() => {
    props.handleChangeSizeIndex(pageIndex, pageSize, props.id);
  }, [pageIndex, pageSize]);

  const handleResetingBatchCheckbox = () => {
    setRowSelectionState({});
    setRowSelectedArray([]);
    setRowSelection({});
  };

  useEffect(() => {
    if (resetRowSelection) {
      handleResetingBatchCheckbox();
    }
  }, [resetRowSelection]);

  useEffect(()=>{
    if(dataQueryState){
      // console.log("--- Data Query ----");
      // console.log(dataQueryState);
      setSearchResultLength(dataQueryState?.data?.rows?.length);

    }
    
  },[dataQueryState])

  useEffect(() => {
    handleResetingBatchCheckbox();
  }, [unreportedAllTabs.data.id]);

  useEffect(() => {
    // console.log("--- Refresh Required Data -----",refreshRequired);
    if (refreshRequired !== null && refreshRequired[props.id].alreadyLoaded == false) {
      dataQuery.refetch();
    }
  }, [refreshRequired]);

  useEffect(() => {
    if (refreshRequired[props.id].alreadyLoaded == false) {
      setTimeout(() => {
        dataQuery.refetch();
      }, 10);
    }
  }, [props.id]);

  useEffect(() => {
    setRowSelectionState(rowSelection);
  }, [rowSelection]);

  // const { mutate: fetchAndUpdatePriorsRow } = useMutation({
  //   onMutate: async ({ studyId, priorsRow }) => {
  //     console.log(priorsRow);
  //     //fetch priors data
  //     await queryClient.cancelQueries(["data", fetchDataOptions]);
  //     let newStudyData = queryClient.getQueryData(["data", fetchDataOptions]);
  //     newStudyData.rows = newStudyData.rows.map((study) => {
  //       if (study.id === studyId) {
  //         return {
  //           ...study,
  //           priors: priorsRow,
  //         };
  //       }
  //       return study;
  //     });
  //     console.log(newStudyData);
  //     queryClient.setQueryData(["data", fetchDataOptions], () => {
  //       return newStudyData;
  //     });
  //   },
  //   onSuccess: () => {
  //     queryClient.invalidateQueries(["data", fetchDataOptions]);
  //   },
  // });

  const batchAssign = (dto, selection) => {
    if (selection == true) {
      console.log(providerDtoList);
      //first remove the dto if that study is already present in some dto
      setProviderDtoList((current) =>
        current.filter((provider) => provider.studyId != dto.studyId)
      );
      //the add the new dto
      setProviderDtoList((current) => [...current, dto]);
    } else {
      setProviderDtoList((current) =>
        current.filter((provider) => provider.studyId != dto.studyId)
      );
    }
  };

  const columns = useMemo(
    () => [
      {
        id: "select",
        show: true,
        style: { width: widthOfColumns(props.roles[0]).selectColumn },
        header: ({ table }) => (
          <div style={{position:'relative',height:"16px",display:'flex'}}>
          <IndeterminateCheckbox
            {...{
              header: true,
              checked: table.getIsAllRowsSelected(),
              roles: props.roles,
              data: props,
              table:table,
              rowSelection:rowSelection,
              indeterminate: table.getIsSomeRowsSelected(),
              onChange: table.getToggleAllRowsSelectedHandler(),
            }}
          /></div>
        ),
        cell: ({ row }) => (
          <div className="px-1" style={{height:"100%"}}>
            <IndeterminateCheckbox
              {...{
                row,
                header: false,
                checked: row.getIsSelected(),
                roles: props.roles,
                data: props,
                table:table,
                rowSelection:rowSelection,
                disabled: !row.getCanSelect(),
                indeterminate: row.getIsSomeSelected(),
                onChange: row.getToggleSelectedHandler(),
              }}
            />
          </div>
        ),
      },
      {
        id: "patientDetails",
        show: true,
        style: { width: widthOfColumns(props.roles[0]).patientColumn },
        accessorFn: (row) => row.id,
        accessorKey: "patientDetails",
        cell: (info) => <PatientDetails data={info} roles={props.roles} tabId={props.id} />,
        header: () => (
          <span className="study-list-header-txt">{t("study-list.column.patient-details")}</span>
        ),
        footer: (props) => props.column.id,
      },
      {
        id: "studies",
        show: true,
        style: { width: widthOfColumns(props.roles[0]).studyColumn },
        header: () => (
          <span className="study-list-header-txt">{t("study-list.column.study-details")}</span>
        ),
        accessor: "studies",
        accessorKey: "username",
        cell: (info) => <StudyDetails data={info} tabId = {props.id} />,
      },
      {
        id: "clients",
        style: { width: widthOfColumns(props.roles[0]).clientColumn },
        header: () => (
          <span className="study-list-header-txt">{props.roles[0] != USERTYPES.ADMIN?t("study-list.column.client-details")
          :t("study-list.column.firm-details")}</span>
        ),
        accessor: "clients",
        accessorKey: "clients",
        show: 
          (props.roles[0] != USERTYPES.TYPIST &&
          props.roles[0] != USERTYPES.RADIOLOGIST),
        cell: (info) => <ClientDetails data={info} tabId={props.id} />,
      },
      {
        id: "qcDetails",
        style: { width: widthOfColumns(props.roles[0]).qcColumn },
        header: () => (
          <span className="study-list-header-txt">{t("study-list.column.qc-details")}</span>
        ),
        accessor: "qcDetails",
        accessorKey: "qcDetails",
        show:
          (props.roles[0] == USERTYPES.SUPERVISOR ||
          props.roles[0] == USERTYPES.FIRMADMIN) && QC_TABS_NAME.includes(props.id),
        cell: (info) => <QCDetails data={info} tabId={props.id} />,
      },
      {
        id: "radiologist",
        show: true,
        style: { width: widthOfColumns(props.roles[0]).radiologistColumn },
        header: () => (
          <span className="study-list-header-txt">{props.roles[0] === USERTYPES.RADIOLOGIST?t("study-list.column.radiologist-firm")
          :t("study-list.column.provider-details")}
          </span>
        ),
        accessor: "radiologist",
        accessorKey: "radiologist",
        cell: (info) => (
          <RadiologistDetails data={info} batchAssign={batchAssign} tabId={props.id} />
        ),
      },
      {
        id: "reportDetails",
        style: { width: widthOfColumns(props.roles[0]).reportColumn },
        show: true,
        header: () => (
          <span className="study-list-header-txt">{t("study-list.column.report-details")}</span>
        ),
        accessor: "reportDetails",
        accessorKey: "reportDetails",
        cell: (info) => <ReportDetails data={info} tabId={props.id} table={table}/>,
      },
      {
        id: "actions",
        style: { width: widthOfColumns(props.roles[0]).actionColumn },
        show: props.roles[0] != USERTYPES.TYPIST && !ARCHIVED_STUDY_TABS_NAME.includes(props.id),
        header: () => (
          <span
            className="study-list-header-txt"
            style={{ justifyContent: "center" }}
          >
            {t("study-list.column.actions")}
          </span>
        ),
        accessor: "actions",
        accessorKey: "actions",
        cell: (info) => <ActionDetails data={info} tabId={props.id} />,
      },
      {
        id: "triage",
        style: {
          width: widthOfColumns(props.roles[0]).triageColumn,
          paddingRight: "10px",
        },
        show:
          // props.roles[0] != USERTYPES.FIRMDOCTOR &&
          // props.roles[0] != USERTYPES.FIRMTECHNICIAN && 
          props.roles[0] != USERTYPES.TYPIST && !ARCHIVED_STUDY_TABS_NAME.includes(props.id),
          
        header: () => (
          <span
            className="study-list-header-txt"
            style={{ justifyContent: "center" }}
          >
            {t("study-list.column.alerts")}
          </span>
        ),
        accessor: "triage",
        accessorKey: "triage",
        cell: (info) => <TriageDetails data={info} tabId={props.id} />,
      },
      {
        id: "requestDetails",
        style: { width: widthOfColumns(props.roles[0]).requestDetails },
        show: props.roles[0] == USERTYPES.FIRMADMIN && ARCHIVED_STUDY_TABS_NAME.includes(props.id),
        header: () => (
          <span
            className="study-list-header-txt"
          >
            {t("study-list.column.request-details")}
          </span>
        ),
        accessor: "requestDetails",
        accessorKey: "requestDetails",
        cell: (info) => <RequestDetails data={info} tabId={props.id} />,
      },
    ],
    []
  );
;

  const mobileColumns = useMemo(
    () => [
      {
        id: "patientDetails",
        show: true,
        accessorFn: (row) => row.id,
        accessorKey: "patientDetails",
        cell: (info) => <MobileListComponent data={info} roles={props.roles} />,
        header: () => (
          <span className="study-list-header-txt">{t("study-list.column.patient-details")}</span>
        ),
        footer: (props) => props.column.id,
      },
    ],
    []
  );

  useEffect(() => {
    //to emply the dto list and refresh the rows when closing the batch assign toast
    if (assignToastId != 0) {
      let duplicateList = list;
      const isFound = duplicateList.some((element) => {
        if (element.id === assignToastId) {
          return true;
        }
        return false;
      });
      if (!isFound) {
        setProviderDtoList([]);
        setAssignToastId(0);
        //also have to update the rows
      }
    }
  }, [list]);

  var valuesTemp = null;

  useEffect(() => {
    //for calling the batch assign toast
    const listlength = providerDtoList.length;
    // console.log("--- Values ---",providerDtoList);
    valuesTemp = providerDtoList;
    let toastId = 0;
    const uniqueProviderDto = new Set();
    for (const obj of providerDtoList) {
      uniqueProviderDto.add(obj.providerId);
    }
    const uniqueProvider = uniqueProviderDto.size;
    if (providerDtoList.length == 2 && assignToastId == 0) {
      toastId = showToastv2(
        TOAST_TYPE.BATCHASSIGN,
        `Assigning ${uniqueProvider} ${uniqueProvider > 1 ?"providers":"provider"} to ${listlength} Studies`,
        ()=>{handleBatchAssign(valuesTemp)}
      );
      setAssignToastId(toastId);
    } else if (providerDtoList.length >= 2 && assignToastId != 0) {
      updateToastv2(
        assignToastId,
        TOAST_TYPE.BATCHASSIGN,
        `Assigning ${uniqueProvider} ${uniqueProvider > 1 ?"providers":"provider"} to ${listlength} Studies`,
        ()=>{handleBatchAssign(valuesTemp)}
      );
    } else if (providerDtoList.length < 2 && assignToastId != 0) {
      const toastListItem = list.filter((e) => e.id !== assignToastId);
      setList(toastListItem);
      setAssignToastId(0);
    }
  }, [providerDtoList]);

  useEffect(()=>{
    if(batchAssignClick){
      handleBatchAssign(providerDtoList);
    }
  },[batchAssignClick]);

  const handleRowsUpdateForBatchUpdate = (providerList) => {
      let list = [];
      let dataQueryStateRows = dataQueryState;
    providerList.map((item,index)=>{
      var currentDate = Moment().format('DD-MMM-YY HH:mm');
      let newIndex = -1; 
      let newData = dataQueryState?.data?.rows.filter(
        (row, index) => {
          if (row.id == item.studyId) {
            newIndex = index; 
            return true; 
          }
          return false;
        }
      );
      
      dataQueryStateRows.data.rows[newIndex].assignmentList[0].providerName = item.assignName;
      dataQueryStateRows.data.rows[newIndex].assignmentList[0].providerId = item.providerId;
      dataQueryStateRows.data.rows[newIndex].assignmentList[0].assignmentDateDisplay = currentDate;
    });  
    return dataQueryStateRows.data.rows;  
  }
  

  const handleBatchAssign = async () => {
      console.log(providerDtoList);     
    const body = {
      reportingProviderList: { batchProviders: providerDtoList },
      baseURL: baseURL,
    };
    console.log(body);
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await batchAssignProvider(body);
    console.log(response);
    if (response.status === 200 && response.data.result === "SUCCESS") {
      showToastv2(TOAST_TYPE.SUCCESS, "Studies are assigned sucessfully!");
      setLoaderRunning(false);
      ref.current.complete();
        let data = handleRowsUpdateForBatchUpdate(providerDtoList);
        setDataQueryState(() => {
          const newValue = {
            ...dataQueryState
          };
          newValue.data.rows = data;
          return newValue;
        });
     
      
      
      
     
      setBatchAssignClick(false);
      const toastListItem = list.filter((e) => e.id !== assignToastId);
      setList(toastListItem);
      setAssignToastId(0);
      setProviderDtoList([]);
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, "Studies are not assigned sucessfully!");
      setBatchAssignClick(false);
      const toastListItem = list.filter((e) => e.id !== assignToastId);
      setList(toastListItem);
      setAssignToastId(0);
      setProviderDtoList([]);
    }
  };

  const dataQuery = useQuery(
    ["data", fetchDataOptions],
    () => fetchData(fetchDataOptions),
    {
      keepPreviousData: true,
      staleTime: Infinity, // Set stale time to 5 minutes
      cacheTime: 15 * 60 * 1000, // Set cache time to 5 minutes
      initialData: () => {
        return queryClient.getQueryData(["data"]);
      },
      initialDataUpdatedAt: () =>
        queryClient.getQueryState(["data"])?.dataUpdatedAt,
    }
  );

  //   const dataQuery = useQuery({
  //     queryKey: ["data", fetchDataOptions],
  //     queryFn : () => props.fetchData(fetchDataOptions),
  //     keepPreviousData: true,
  //     staleTime: Infinity,
  //     cacheTime:15000,
  //     initialData: () => {
  //       console.log("------- @@@@@@@@@@@ --------");
  //       console.log(queryClient.getQueriesData(["data"]));
  //       return null;
  //     }
  // });

  const updateDataQueryState = (newData) => {
    setDataQueryState(() => {
      const newValue = {
        ...dataQueryState,
      };
      newValue.data.rows = newData;
      return newValue;
    });
  };

  const table = useReactTable({
    data: dataQueryState?.data?.rows ?? defaultData,
    columns: isMobile ? mobileColumns : columns,
    pageCount: dataQueryState?.data?.pageCount ?? -1,
    state: {
      pagination,
      rowSelection,
      expanded,
    },
    onPaginationChange: setPagination,
    onRowSelectionChange: setRowSelection,
    getCoreRowModel: getCoreRowModel(),
    // getExpandedRowModel: getExpandedRowModel,
    // getExpandedRowModel: (row) => fetchPriorsData(row),
    onExpandedChange: setExpanded,
    enableSubRowSelection: false,
    manualPagination: true,
    manualExpanding: true,
    meta: {
      removeRowFromStudyList: (studyId) => {
        let newData = dataQueryState?.data?.rows.filter(
          (row) => row.id !== studyId
        );
        updateDataQueryState(newData);
      },
      updateTriageDetailFromStudyList: (studyId, maxAiEmergency) => {
        let newTriageDetails = dataQueryState?.data?.rows.map((row) =>{
          return row.id === studyId ? {...row, aiEmergencyMax:maxAiEmergency} : row;
        });
        updateDataQueryState(newTriageDetails);
      },
    },
    // getPaginationRowModel: getPaginationRowModel(), // If only doing manual pagination, you don't need this
    debugTable: true,
  });

  useEffect(() => {
    // console.log("Stored item",storedRows,pageIndex);
    // if(storedRows[id] == undefined || ( storedRows[id] != undefined &&  storedRows[id]?.rows?.length == 0 || (storedRows[id]?.pageIndex != pageIndex))){
    if (dataQuery.isFetching) {
      // setStudyListLoading(true);
      // studyListRef.current.continuousStart();
      //setLoaderRunning(true);
      //ref.current.continuousStart();
    } else {
      //ref.current.complete();
      studyListRef.current.complete();
      setRefreshRequired(() => {
        const newItem = { ...refreshRequired };
        newItem[props.id].alreadyLoaded = true;
        return newItem;
      });
    }
    // }else{
    //  ref.current.complete();
    // }
  }, [dataQuery.isFetching]);

  useEffect(() => {
    // console.log("DATA QUERY")
    // console.log(dataQuery)
    if (dataQuery.isFetched) {
      setFirstTimeLoading(false);
      props.setDataQueryParent(dataQuery);
      setDataQueryState(dataQuery);
    }
  }, [dataQuery.isFetched, dataQuery.isFetching]);

  useEffect(() => {
    // console.log("Clicked refresh");
    // console.log(dataQuery);
    // console.log(table.getRowModel());
    // setDataQueryState(dataQuery)
  }, [dataQuery.data]);

  const handlePaginationAlgo = (
    currentPageNumber,
    totalPageNumber,
    offset = 2
  ) => {
    currentPageNumber = currentPageNumber+1;
    const offsetNumber =
      currentPageNumber <= offset ||
      currentPageNumber > totalPageNumber - offset
        ? offset
        : offset - 1;
    const numbersList = [];
    const numbersListWithDots = [];

    // If itemsPerPage is less than what the user selected with the Select component or if there is no page or only one page:
    if (totalPageNumber <= 1 || totalPageNumber === undefined) 
    {
      setArrayPageIndex([1]);
      return [1];
    }
    // Create list of numbers:
    numbersList.push(1);
    for (
      let i = currentPageNumber - offsetNumber;
      i <= currentPageNumber + offsetNumber;
      i++
    ) {
      if (i < totalPageNumber && i > 1) {
        numbersList.push(i);
      }
    }
    numbersList.push(totalPageNumber);

    // Add three dots to the list of numbers:
    numbersList.reduce((accumulator, currentValue) => {
      if (accumulator === 1) {
        numbersListWithDots.push(accumulator);
      }
      if (currentValue - accumulator !== 1) {
        numbersListWithDots.push("......");
      }
      numbersListWithDots.push(currentValue);
      return currentValue;
    });
    setArrayPageIndex(numbersListWithDots);
  };

  useEffect(() => {
    // console.log("--- PageIndex ---", pageIndex);
    // console.log("--- Total Pages ---", dataQuery.data?.pageCount);
    let currentPageNumber = pageIndex;
    let totalPageNumber = dataQuery.data?.pageCount;
    handlePaginationAlgo(currentPageNumber, totalPageNumber);
  }, [
    dataQuery.data?.pageCount,
    pageIndex + 1,
    pageSize,
    props.id,
    // dataQuery.data,
    totalRecordCount[activeTab],
    // searchResultLength,
    runPaginationAlgo
  ]);

  useEffect(() => {
    // console.log("---- Data Query Changed ---");
    // console.log(dataQueryState);
  }, [dataQueryState]);


  return !isMobile ? (
    <>
      {table != undefined && (
        <DesktopStudyListTable
          setRowSelection={setRowSelection}
          containerHeight={containerHeight}
          refresh={props.refresh}
          id={props.id}
          table={table}
          dataQuery={dataQuery}
          roles = { roles }
        />
      )}

      {dataQuery.isFetched && (
        <>
          <div className="study-list-bottom-container">
                <div className="pagination-section">
                    <TablePaginationv2
                        table={table}
                        arrayPageIndex={arrayPageIndex}
                        showCount={showCount}
                        setShowCount={setShowCount}
                        setPagination={setPagination}
                        pageIndex={pageIndex}
                        pageSize={pageSize}
                        pagination={pagination}
                        roles={roles}
                        showPageSize={true}
                        showBrowserCheck={true}
                    />
                </div>
                {!isVdcPlatform && (
                  <>
                  {studyCountLoading  ? (
                    <div className="study-count-summary" style={{fontStyle: "italic"}}>
                      {t("analytics.loading")}
                    </div>
                  ) : (
                <div className="study-count-summary" 
                style={{ marginRight: isChrome ? "15px" : "80px" }}
                >
                    <span>Previous day:</span><span className="study-count-saperator2"></span>
                    <span>Total Studies: {studyCounts?.totalStudies}</span><span className="study-count-saperator2">|</span>
                    <span>Reported: {studyCounts?.totalReported}</span><span className="study-count-saperator2">|</span>
                    {/* <span> Unreported: {studyCounts?.totalUnreported} |</span> */}
                    {/* <span>Unreported: {studyCounts.totalStudies && studyCounts.totalReported ? studyCounts.totalStudies - studyCounts.totalReported : 0}</span><span className="study-count-saperator">|</span> */}
                    <span>Unreported: {(studyCounts?.totalStudies != null && studyCounts?.totalReported != null)? studyCounts.totalStudies - studyCounts.totalReported: 0}</span><span className="study-count-saperator2">|</span> 
                    <span>Assigned: {studyCounts?.totalAssigned}</span>
                    {/* <span>Locked by You: {studyCounts?.totalLockedByYou}</span> */}
                    {roles?.[0] === USERTYPES.RADIOLOGIST && (
                      <>
                        <span className="study-count-saperator2">|</span>
                        <span>Locked by You: {studyCounts?.totalLockedByYou}</span>
                      </>
                    )}
                </div>
                )}
                </>
                )}
                <BrowserCheck onBrowserDetect={(browserIsChrome) => setIsChrome(browserIsChrome)} />
            </div>
        </>
      )}
      
    </>
  ) : (
    <>
      <MobileStudyListTable table={table} />
    </>
  );
};

export default StudyListTable;
